import { MenuItem, Select } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import "react-quill/dist/quill.snow.css";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { constants } from "../../../constants/constants";
import {
  createMobilePage,
  updateMobilePage,
} from "../../../utils/ApiCalls/AddMobilePage";
import { uploadFile } from "../../../utils/ApiCalls/Document";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { getActivityCategory } from "../../../utils/ApiCalls/Mobile/ActivityMasters";
import { getVenueMaster } from "../../../utils/ApiCalls/Mobile/VenueMaster";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import { uploadData } from "../../../utils/ApiCalls/Upload";
import DyanmicFromMobile from "../../DyanmicForm/DyanmicFromMobile";
import RichEditor from "../../DyanmicForm/RichTextEditor";
import UploadFileImage from "../../imageUpload/uploadFileImage";
import { fieldsName, mobile_fields } from "./MobilePageFields";
import VenueSelect from "./VenueSelect";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";

const MobilePagemasterInput = ({
  pageData,
  category,
  activityCategory,
  vesselData,
}) => {
  const [description, setDescription] = useState("");
  const [title, setTitle] = useState("");
  const [simplified_chinese_title, setSimplifiedChineseTitle] = useState("");
  const [traditional_chinese_title, setTraditionalChineseTitle] = useState("");
  const [simplifiedChineseDescription, setSimplifiedChineseDescription] =
    useState("");
  const [traditionalChineseDescripton, setTraditionalChineseDescripton] =
    useState("");
  const [isActive, setIsActive] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);

  const [vesselOptions, setVesselOptions] = useState([]);
  const [fields, setFields] = useState([]);
  const [activitycategoryOption, setactivitycategoryOption] = useState([]);
  const [venueOption, setVenueOption] = useState([]);
  const [veune_id, setVenueId] = useState();
  const [parentCat, setParentCat] = useState();
  const [shoreCMS, setShoreCMS] = useState({});
  const originalShoreData = useRef({});
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  
  console.log("FORM DATA -", shoreCMS);

  useEffect(() => {
    if (pageData) {
      setSelectedFile(pageData?.image);
      setSelectedThumbnail(pageData?.thumbnail_image);
      setParentCat(pageData?.child_category_id);
      setVenueId(pageData?.venue_id);
      setDescription(pageData?.description);
      setSimplifiedChineseTitle(pageData?.simplified_chinese_title);
      setTraditionalChineseTitle(pageData?.traditional_chinese_title);
      setTitle(pageData?.title);
      setIsActive(pageData?.is_active);
      const shoreData = pageData?.shore_data || {};
      setShoreCMS(shoreData);
      originalShoreData.current = JSON.parse(JSON.stringify(shoreData));
      setSimplifiedChineseDescription(
        pageData?.simplified_chineses_description
      );
      setTraditionalChineseDescripton(
        pageData?.traditional_chinese_description
      );
    }
  }, [pageData, vesselData]);

  useEffect(() => {
    if (category?.id && category?.shore_cms) {
      let val = Array(fieldsName.length).fill("hii");
      Object.keys(category.shore_cms).forEach((item) => {
        if (category.shore_cms[item] === true) {
          if (mobile_fields[item]) {
            let index = fieldsName.findIndex((val) => val == item);
            val[index] = mobile_fields[item];
          }
        }
      });

      val = val.filter((item) => item != "hii");
      setFields(val);
      console.log({ val }, category?.shore_cms);
    }
  }, [category]);
  const handleCheckboxChange = () => {
    setIsActive(!isActive);
  };
  const handleQuickAccessNameChange = (lang, value) => {
    setShoreCMS({
      ...shoreCMS,
      quick_access_button: {
        ...shoreCMS?.quick_access_button,
        name: {
          ...shoreCMS?.quick_access_button?.name,
          [lang]: value,
        },
      },
    });
  };
  const handleQuickAccessLinkChange = (value) => {
    setShoreCMS({
      ...shoreCMS,
      quick_access_button: {
        ...shoreCMS?.quick_access_button,
        link: value,
      },
    });
  };
  const fileKeys = [
    "image",
    "image1",
    "image2",
    "image3",
    "image4",
    "image5",
    "arabic_image",
    "simplified_chinese_image",
    "traditional_chinese_image",
    "popup_image",
    "simplified_chinese_popup_image",
    "traditional_chinese_popup_image",
    "english_file",
    "simplified_chinese_file",
    "traditional_chinese_file",
    "star_cruises_english_file",
    "star_cruises_simplified_chinese_file",
    "star_cruises_traditional_chinese_file",
    "arabic_file",
    "logo",
    "simplified_chinese_logo",
    "english_menu",
    "simplified_chinese_menu",
    "traditional_chinese_menu",
    "traditional_chinese_logo",
    "arabic_logo",
    "english_file_1",
    "simplified_chinese_file_1",
    "traditional_chinese_file_1",
    "arabic_file_1",
    "english_file_2",
    "simplified_chinese_file_2",
    "traditional_chinese_file_2",
    "arabic_file_2",
  ];
  const uploadImagesRecursively = async (data, originalData = {}) => {
    try {
      for (const key in data) {
        if (data[key] && typeof data[key] === "object") {
          for (const fileKey of fileKeys) {
            if (data[key][fileKey])
              if (
                data[key][fileKey] !== undefined &&
                data[key][fileKey] !== null
              ) {
                const oldValue = typeof originalData[key]?.[fileKey] === "string"
                  ? originalData[key][fileKey]
                  : null;
                data[key][fileKey] = await handleFileUpload(
                  data[key][fileKey],
                  fileKey,
                  oldValue
                );
              } else {
                data[key][fileKey] = "";
              }
          }

          await uploadImagesRecursively(data[key], originalData[key] || {});
        }
      }
    } catch (e) {
      console.log(e);
      Swal.fire(e.message);
    }
  };
  async function handleFileUpload(selectedFile, fileKey, oldFileName = null) {
    if (typeof selectedFile === "string") {
      return selectedFile;
    } else {
      let real;
      if (fileKey?.toString()?.includes("file")) {
        real = "yes";
      }
      const uploadedFile = await uploadFile(selectedFile, {}, real, oldFileName);
      if (uploadedFile?.error) throw new Error(uploadedFile.error);
      return uploadedFile.url;
    }
  }

  const addcrisisData = async (e) => {
    e.preventDefault();
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    // maximum_count comes off a type="number" input as a numeric string -
    // coerce to a real number only when something was actually entered;
    // left empty, it stays empty (no 0 default - that would misleadingly
    // read as "maximum 0 participants")
    const normalizedShoreCMS = shoreCMS?.no_of_pat
      ? {
          ...shoreCMS,
          no_of_pat: {
            ...shoreCMS.no_of_pat,
            maximum_count:
              shoreCMS.no_of_pat.maximum_count === "" ||
              shoreCMS.no_of_pat.maximum_count === undefined ||
              shoreCMS.no_of_pat.maximum_count === null
                ? shoreCMS.no_of_pat.maximum_count
                : Number(shoreCMS.no_of_pat.maximum_count),
          },
        }
      : shoreCMS;

    let dataValues = {
      venue_id: veune_id,
      title: title,
      description: description,
      catergory_id: category?.id,
      child_category_id: parseInt(parentCat),
      simplified_chinese_title,
      traditional_chinese_title,
      simplified_chineses_description: simplifiedChineseDescription,
      traditional_chinese_description: traditionalChineseDescripton,
      shore_data: normalizedShoreCMS,
      is_active: isActive ? 1 : 0,
    };

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
    let newValues = [dataValues];
    await uploadImagesRecursively(newValues, [{ shore_data: originalShoreData.current }]);
    dataValues = newValues[0];
    if (selectedFile) {
      if (typeof selectedFile === "string") {
        dataValues.image = selectedFile.replace(constants.MEDIAURL + "/", "");
      } else {
        const oldImage = typeof pageData?.image === 'string' ? pageData.image : null;
        let image = await uploadData(selectedFile, undefined, oldImage);
        if (image?.e) {
          dispatch({
            type: "SET_ERROR_MESSAGE",
            errMess: { message: image.e.message, type: "error" },
          });
          return;
        }
        dataValues.image = image?.url;
      }
    } else {
      dataValues.image = "";
    }

    if (selectedThumbnail) {
      if (typeof selectedThumbnail === "string") {
        dataValues.thumbnail_image = selectedThumbnail.replace(
          constants.MEDIAURL + "/",
          ""
        );
      } else {
        const oldThumbnail =
          typeof pageData?.thumbnail_image === "string"
            ? pageData.thumbnail_image
            : null;
        let thumbnail = await uploadData(
          selectedThumbnail,
          undefined,
          oldThumbnail
        );
        if (thumbnail?.e) {
          dispatch({
            type: "SET_ERROR_MESSAGE",
            errMess: { message: thumbnail.e.message, type: "error" },
          });
          return;
        }
        dataValues.thumbnail_image = thumbnail?.url;
      }
    } else {
      dataValues.thumbnail_image = "";
    }

    let valid = false;
    if (category?.type == "title" && !dataValues.title) {
      valid = "Please enter English Title.";
    } else if (category?.type == "title" && !dataValues.simplified_chinese_title) {
      valid = "Please enter Simplified Chinese Title.";
    } else if (category?.type == "title" && !dataValues.traditional_chinese_title) {
      valid = "Please enter Traditional Chinese Title.";
    } else if (parentCat !== "NA" && isNaN(dataValues.child_category_id)) {
      valid = "Please select a Sub Category.";
    } else if (!dataValues.image) {
      valid = "Please upload a Page Image.";
    }
    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
    } else {
      setError();

      const values = {
        ...dataValues,
      };

      let data;
      if (pageData?.id) {
        data = await updateMobilePage(pageData?.id, {
          ...values,
          vesselData,
        });
      } else {
        data = await createMobilePage(values);
      }
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        return;
      }
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });

      let slug =
        "/shore/all-pages/" +
        vesselOptions
          .find((item) => item.id == category?.vessel_id)
          ?.name?.replaceAll(" ", "-")
          ?.toLowerCase() +
        "/" +
        category.id;
      let id = pageData?.id || data?.id;
      if (!pageData?.id) {
         addlog(
          LOG_ACTIONS.CREATED,
          category?.name + category?.vessel_id,
          {
            id, title:  
             `${title}, ${category?.name} Page`,
          },
          userDetails.id
        );
        navigate(`${slug}${location.search || ""}`);
      } else {
        addlog(
          LOG_ACTIONS.UPDATED,
          category?.name + category?.vessel_id,
          { id ,title:`${title}, ${category?.name} Page`},
          userDetails.id
        );
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: "Values updated", type: "success" },
        });
        navigate(`${slug}${location.search || ""}`);
      }
    }
  };

  useEffect(() => {
    if (category?.id) getOptionLocation();
  }, [category]);

  useEffect(() => {
    console.log({ parentCat });
  }, [parentCat]);
  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    let data = await getVenueMaster({
      page: 1,
      limit: 2000,
      vessel_id: category?.vessel_id,
    });

    let cat = await getActivityCategory({
      page: 1,
      limit: 2000,
      parent_category: category?.id,
      is_active: 1,
      vessel_id: category?.vessel_id,
    });
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVenueOption(data?.venueMasterList);
      setactivitycategoryOption(cat?.data);
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    console.log({ vesselData });
  }, [vesselData]);
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addcrisisData}>
              <div className="card-body">
                <div className="row">
                  {category?.type == "title" && (
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">English Title <span style={{color:'red'}}>*</span></label>
                        <input
                          value={title}
                          className="f_input"
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                  {category?.type == "title" && (
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          Simplified Chinese Title <span style={{color:'red'}}>*</span>
                        </label>
                        <input
                          value={simplified_chinese_title}
                          className="f_input"
                          onChange={(e) =>
                            setSimplifiedChineseTitle(e.target.value)
                          }
                        />
                      </div>
                    </div>
                  )}
                  {category?.type == "title" && (
                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">
                          Traditional Chinese Title <span style={{color:'red'}}>*</span>
                        </label>
                        <input
                          value={traditional_chinese_title}
                          className="f_input"
                          onChange={(e) =>
                            setTraditionalChineseTitle(e.target.value)
                          }
                        />
                      </div>
                    </div>
                  )}

                  {/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                  {/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                  {/* ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */}
                  {category?.type == "venue" && (
                    <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">Venue</label>
                        <VenueSelect
                          venueOption={venueOption}
                          venueId={veune_id}
                          setVenueId={setVenueId}
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Sub Category <span style={{color:'red'}}>*</span></label>
                      <Select
                        style={{ width: "100%", height: "45px" }}
                        value={parentCat + ""}
                        onChange={(e) => setParentCat(e.target.value)}
                      >
                        {activitycategoryOption.map((item, index) =>
                          item.id == category.id ? undefined : item.name ==
                            activityCategory?.name ? null : (
                            <MenuItem key={index + ""} value={item?.id + ""}>
                              <div
                                dangerouslySetInnerHTML={{ __html: item.name }}
                              ></div>
                            </MenuItem>
                          )
                        )}
                      </Select>
                    </div>
                  </div>

                  <div
                    style={{
                      background: "lightgray",
                      height: "30px",
                      display: "flex",
                      border: "1px solid black",
                      alignItems: "center",
                      padding: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      fontWeight: "400",
                    }}
                    className="col-lg-12"
                  >
                    <p style={{ fontWeight: "bolder" }}>Add Common Details</p>
                  </div>
                  <UploadFileImage
                    className={"col-lg-12"}
                    mandatory={"*"}
                    width={600}
                    height={400}
                    image={
                      pageData?.image
                        ? `${constants.MEDIAURL}/${pageData?.image}`
                        : pageData?.image
                    }
                    label={"Page  Image"}
                    placeholder={"Upload Page Image"}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                  <UploadFileImage
                    className={"col-lg-12"}
                    width={255}
                    height={255}
                    image={
                      pageData?.thumbnail_image
                        ? `${constants.MEDIAURL}/${pageData?.thumbnail_image}`
                        : pageData?.thumbnail_image
                    }
                    label={"Thumbnail Image"}
                    placeholder={"Upload Thumbnail Image"}
                    selectedFile={selectedThumbnail}
                    setSelectedFile={setSelectedThumbnail}
                  />
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">English Description</label>
                      <RichEditor
                        data={description}
                        setData={(e) => {
                          setDescription(e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Description
                      </label>
                      <RichEditor
                        data={simplifiedChineseDescription}
                        setData={(e) => setSimplifiedChineseDescription(e)}
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Description
                      </label>
                      <RichEditor
                        data={traditionalChineseDescripton}
                        setData={setTraditionalChineseDescripton}
                      />
                    </div>
                  </div>

                  <div
                    style={{
                      background: "lightgray",
                      height: "30px",
                      display: "flex",
                      border: "1px solid black",
                      alignItems: "center",
                      padding: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      fontWeight: "400",
                    }}
                    className="col-lg-12"
                  >
                    <p style={{ fontWeight: "bolder" }}>Quick Access Button</p>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">English Button Name</label>
                      <input
                        value={shoreCMS?.quick_access_button?.name?.english || ""}
                        className="f_input"
                        onChange={(e) =>
                          handleQuickAccessNameChange("english", e.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Button Name
                      </label>
                      <input
                        value={
                          shoreCMS?.quick_access_button?.name
                            ?.simplified_chinese || ""
                        }
                        className="f_input"
                        onChange={(e) =>
                          handleQuickAccessNameChange(
                            "simplified_chinese",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Button Name
                      </label>
                      <input
                        value={
                          shoreCMS?.quick_access_button?.name
                            ?.traditional_chinese || ""
                        }
                        className="f_input"
                        onChange={(e) =>
                          handleQuickAccessNameChange(
                            "traditional_chinese",
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Page Slug</label>
                      <input
                        value={shoreCMS?.quick_access_button?.link || ""}
                        className="f_input"
                        onChange={(e) =>
                          handleQuickAccessLinkChange(e.target.value)
                        }
                      />
                      <p className="text-secondary">
                        {`${constants.PRODUCTION_URL}/${shoreCMS?.quick_access_button?.link || ""}`}
                      </p>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      background: "lightgray",
                      height: "30px",
                      display: "flex",
                      border: "1px solid black",
                      alignItems: "center",
                      padding: "10px",
                      marginBottom: "10px",
                      marginTop: "10px",
                      fontWeight: "400",
                    }}
                    className="col-lg-12"
                  >
                    <p style={{ fontWeight: "bolder" }}>Static Input Fields</p>
                  </div>
                  <DyanmicFromMobile
                    error={error}
                    rootData={shoreCMS}
                    queryData={{ vessel_id: category?.vessel_id }}
                    level={1}
                    attributes={fields || []}
                    data={shoreCMS}
                    setData={(e) => {
                      setShoreCMS(e);
                    }}
                  />
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {pageData?.id ? "Update" : "Add"} Page
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default MobilePagemasterInput;
